module.exports = __webpack_public_path__ + "src/assets/img/meridian.addd65c8.png";